export type ShiftAPIResponse = {
  id: number
  name: string
  enabled: boolean
  order: number
  slots: number[]
  begin_time: string
  end_time: string
  is_deletable: boolean
  enabled_days: {
    values: number[]
  }
  created: Date
  device_update: Date
  updated: Date
}

export type Shift = {
  id: number
  name: string
  enabled: boolean
  order: number
  slots: number[]
  beginTime: string
  endTime: string
  isDeletable: boolean
  enabledDays: {
    values: number[]
  }
  created: Date
  deviceUpdate: Date
  updated: Date
}

export class ShiftsAPIServiceError extends Error {}

export interface IShiftsAPIService {
  fetch: () => Promise<Shift[]>
}
